module.exports = __webpack_public_path__ + "img/Middle-Semi-Elliptical-Attachment-R-12.9697f18f.png";